import { ComponentPropsWithoutRef } from 'react';
import * as AuctionTooltip from 'components/pages/campaign-settings/campaign-auction/AuctionTooltip';
import { AuctionTooltipContentProps } from 'components/pages/campaign-settings/campaign-auction/AuctionTooltip';
import { twMerge } from 'tailwind-merge';

interface NotificationSettingControlProps extends ComponentPropsWithoutRef<'div'> {}
const NotificationSettingControl = ({
    className = '',
    ...rest
}: NotificationSettingControlProps) => {
    return <div className={twMerge('col-span-1 place-self-center', className)} {...rest} />;
};

interface NotificationSettingLabelProps extends ComponentPropsWithoutRef<'div'> {}
const NotificationSettingLabel = ({ className = '', ...rest }: NotificationSettingLabelProps) => {
    return (
        <div className={twMerge('col-span-4', className)}>
            <div className={'flex items-center gap-x-2'} {...rest} />
        </div>
    );
};

interface NotificationSettingRootProps extends ComponentPropsWithoutRef<'div'> {}
const NotificationSetting = ({ className = '', ...rest }: NotificationSettingRootProps) => {
    return <div className={twMerge('grid grid-cols-6 px-8 py-5', className)} {...rest} />;
};

interface NotificationSettingTextProps extends ComponentPropsWithoutRef<'p'> {}
const NotificationSettingText = (props: NotificationSettingTextProps) => {
    return <p className="text-base font-medium" {...props} />;
};

interface NotificationSettingTooltipProps extends AuctionTooltipContentProps {}
const NotificationSettingTooltip = (props: NotificationSettingTooltipProps) => {
    return (
        <AuctionTooltip.Root>
            <AuctionTooltip.Trigger />
            <AuctionTooltip.Content {...props} />
        </AuctionTooltip.Root>
    );
};

const Root = NotificationSetting;
const Control = NotificationSettingControl;
const Label = NotificationSettingLabel;
const Text = NotificationSettingText;
const Tooltip = NotificationSettingTooltip;

export {
    NotificationSetting,
    NotificationSettingControl,
    NotificationSettingLabel,
    NotificationSettingText,
    NotificationSettingTooltip,
    //
    Root,
    Control,
    Label,
    Text,
    Tooltip,
};

export type {
    NotificationSettingControlProps,
    NotificationSettingLabelProps,
    NotificationSettingRootProps,
    NotificationSettingTextProps,
    NotificationSettingTooltipProps,
};
